import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyMax]',
  standalone: true
})
export class CurrencyMaxDirective implements OnInit {

  @Input() maxInteger: string = '10000000000000000'; // 17 inteiros
  @Input() maxDigits: number = 19; // 17 inteiros + 2 decimais
  @Input() valorExcedeMaxFlag!: { value: boolean };

  constructor(private ngControl: NgControl) {}

  ngOnInit(): void {
    const initial = this.ngControl.control?.value;

    if (initial != null && initial !== '') {
      const formatted = this.formatValue(initial);
      this.ngControl.control?.setValue(formatted, { emitEvent: false });
    }

    // se o valor mudar via form.patchValue (edição), já aplicar máscara
    this.ngControl.control?.valueChanges.subscribe(value => {
      if (value != null && !this.isFormatted(value)) {
        const formatted = this.formatValue(value);
        this.ngControl.control?.setValue(formatted, { emitEvent: false });
      }
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formatted = this.formatValue(input.value);
    input.value = formatted;
    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }

  private formatValue(raw: string | number): string {
    if (raw === null || raw === undefined) return '';

    // se vier número, converter para string com 2 casas
    let str = typeof raw === 'number'
      ? raw.toFixed(2) // backend: 218648978978 → "218648978978.00"
      : raw.toString();

    // remove tudo que não for número
    let value = str.replace(/\D/g, '');
    if (!value) return '';

    // limita número de dígitos
    if (value.length > this.maxDigits) {
      value = value.substring(0, this.maxDigits);
    }

    // separa inteiro e decimal (2 últimas casas)
    let intPart = value.slice(0, -2) || '0';
    let decPart = value.slice(-2);

    // remove zeros à esquerda
    intPart = intPart.replace(/^0+/, '') || '0';

    // valida maxValue
    const totalValue = BigInt(intPart + decPart.padStart(2, '0'));
    const maxValue = BigInt(this.maxInteger + '00');

    if (totalValue > maxValue) {
      intPart = this.maxInteger;
      decPart = '00';
      if (this.valorExcedeMaxFlag) this.valorExcedeMaxFlag.value = true;
    } else {
      if (this.valorExcedeMaxFlag) this.valorExcedeMaxFlag.value = false;
    }

    // aplica separadores de milhar
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `R$ ${intPart},${decPart}`;
  }

  private isFormatted(value: any): boolean {
    return typeof value === 'string' && value.startsWith('R$');
  }
}
